'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');
require('richemont/libs/_app');

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('richemont/components/customSelect'));
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('base/components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('richemont/components/clientSideValidation'));
    processInclude(require('richemont/components/countrySelector'));
    processInclude(require('richemont/components/toolTip'));
    processInclude(require('richemont/components/menu'));
    processInclude(require('richemont/components/search'));
    processInclude(require('richemont/components/wishlist'));
    processInclude(require('richemont/components/reducedHeader'));
    processInclude(require('richemont/components/slider'));
    processInclude(require('./product/charmDetail'));
    processInclude(require('richemont/components/accordion'));
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');
require('slick-carousel');
require('lazysizes');
require('gsap');
